import { render, staticRenderFns } from "./Transition.vue?vue&type=template&id=2f4e61d7"
import script from "./Transition.vue?vue&type=script&lang=ts"
export * from "./Transition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports